import { Component, EventEmitter, OnInit, Output } from '@angular/core';

@Component({
    selector: 'bergh-alert-breach',
    templateUrl: './alert-breach.component.html',
    styleUrls: ['./alert-breach.component.scss'],
    standalone: false
})
export class AlertBreachComponent implements OnInit {
  @Output() cancel : EventEmitter<boolean> = new EventEmitter();
  @Output() isReportBreach : EventEmitter<boolean> = new EventEmitter();
  constructor() { }

  ngOnInit(): void {
  }
  reportBreach() {
    this.isReportBreach.emit(true);
  }
}
